export const menu = [
  { icon: 'mdi-speedometer', title: 'Painel Inicial', routeName: 'Monitor', section: 'GERAL', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR'] },
  { 
    icon: 'mdi-truck', 
    title: 'Cadastro de Transportador', 
    routeName: 'Tranportador', 
    section: 'TRANSPORTE',
    permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] 
  },
  {
    icon: 'mdi-truck-outline',
    title: 'Cadastro de Transportador (novo)',
    routeName: 'TranportadorNovo',
    section: 'TRANSPORTE',
    permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR']
  },
  {
    icon: 'mdi-warehouse',
    title: 'Central de transporte',
    type: 'group',
    section: 'TRANSPORTE',
    permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'],
    subItems: [
      { icon: 'mdi-truck-fast', title: 'Emissão de Viagem', routeName: 'EmissaoViagem', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-package-variant', title: 'Painel de entregas', routeName: 'PainelEntregas', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-monitor-eye', title: 'Monitor de entregas', routeName: 'MonitorEntregas', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      //
      // MDF-e de distribuicao: so MODERADOR e ADMIN. A wi-cadastro-api
      // responde 403 para os demais perfis, entao mostrar o item para
      // eles seria menu que nao abre. A rotina emite documento fiscal e
      // dispara CIOT nas proximas fatias.
      //
      { icon: 'mdi-truck-delivery-outline', title: 'MDF-e de Distribuição', routeName: 'MdfeDistribuicao', permissoes: ['ROLE_MODERADOR', 'ROLE_ADMIN'] },
    ]
  },
  { 
    icon: 'mdi-folder-account', 
    title: 'Cadastros Gerais', 
    type: 'group',
    section: 'CADASTROS',
    permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'],
    subItems: [
      { icon: 'mdi-account-hard-hat', title: 'Motoristas', routeName: 'ListaMotoristas', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-truck-cargo-container', title: 'Veículos', routeName: 'ListaVeiculos', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-file-document-edit', title: 'Cadastro CIOT', routeName: 'ListaCiot', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-file-send', title: 'Emissão CIOT Avulso', routeName: 'CiotAvulsoEmissao', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-file-chart', title: 'Relatório CIOT Avulso', routeName: 'CiotAvulsoRelatorio', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-calculator-variant', title: 'Calculadora Piso Frete (ANTT)', routeName: 'CalculadoraPisoFrete', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-map-marker-path', title: 'Agrupador de Rotas', routeName: 'RotaAgrupador', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN'] },
    ]
  },
  { 
    icon: 'mdi-chart-box', 
    title: 'Relatórios', 
    type: 'group',
    section: 'RELATORIOS',
    permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'],
    subItems: [
      { icon: 'mdi-chart-bar', title: 'Relatórios CT-e', routeName: 'CTE', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-chart-line', title: 'Relatórios MDF-e', routeName: 'MDFE', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-alert-circle', title: 'Pendências integração', routeName: 'RelatorioErrosMdfe', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-map-marker-path', title: 'Relatório de Viagens', routeName: 'RelatorioViagens', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-chart-pie', title: 'Relatório de Produtividade', routeName: 'RelatorioProdutividade', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-file-export', title: 'Exportar PDF/XML', routeName: 'Exportar', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR'] },
      { icon: 'mdi-microsoft-excel', title: 'Exportar XLSX', routeName: 'Xlsx', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      //
      // O Relatorio NFS-e so aparece quando o build recebe a URL da
      // wi-nfse-api. Enquanto a API nao estiver publicada, um item de menu
      // que so responde erro e pior do que nenhum item - e `VUE_APP_*` e
      // inlinado no bundle, entao isto e resolvido no build, nao em runtime.
      //
      // Os perfis sao os tres que a wi-nfse-api aceita (ADMIN, MODERADOR,
      // USUARIO). ROLE_CONTADOR fica de fora de proposito: esta nos outros
      // relatorios, mas a API responderia 403.
      //
      ...(process.env.VUE_APP_NFSE_URL
        ? [{ icon: 'mdi-receipt-text-outline', title: 'Relatório NFS-e', routeName: 'RelatorioNfse', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN'] }]
        : []),
    ]
  },
  { 
    icon: 'mdi-cash-multiple', 
    title: 'Financeiro', 
    type: 'group',
    section: 'FINANCEIRO',
    permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'],
    subItems: [
      { icon: 'mdi-currency-usd', title: 'Faturas', routeName: 'Faturas', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-receipt', title: 'Relatórios Receber', routeName: 'Receber', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR'] },
    ]
  },
  { icon: 'mdi-stop-circle', title: 'Encerrar MDF-e', routeName: 'MDFEE', section: 'TRANSPORTE', permissoes: ['ROLE_MOTORISTA', 'ROLE_USUARIO_MDFE_ENCERRAMENTO'] },
  { icon: 'mdi-percent', title: 'Tributação', routeName: 'Tributacao', section: 'FINANCEIRO', permissoes: ['ROLE_CONTADOR', 'ROLE_MODERADOR', 'ROLE_ADMIN'] },
  { icon: 'mdi-percent-outline', title: 'Tributação (nova)', routeName: 'TributacaoNova', section: 'FINANCEIRO', permissoes: ['ROLE_CONTADOR', 'ROLE_MODERADOR', 'ROLE_ADMIN'] },
  { icon: 'mdi-receipt-text-outline', title: 'NFS-e', routeName: 'NfseConfiguracao', section: 'FINANCEIRO', permissoes: ['ROLE_MODERADOR', 'ROLE_ADMIN'] },
  { icon: 'mdi-file-document', title: 'Contratos', routeName: 'Contratos', section: 'FINANCEIRO', permissoes: ['ROLE_MODERADOR', 'ROLE_ADMIN'] },
  { icon: 'mdi-file-document', title: 'Controle de Novos Contratos', routeName: 'ControleContratos', section: 'FINANCEIRO', permissoes: ['ROLE_MODERADOR', 'ROLE_ADMIN'] },
  { icon: 'mdi-file-document', title: 'Rotinas ADM', routeName: 'Rotina-adm', section: 'FINANCEIRO', permissoes: ['ROLE_MODERADOR', 'ROLE_ADMIN'] },
  {
    icon: 'mdi-cog',
    title: 'Configurações',
    type: 'group',
    section: 'SISTEMA',
    permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'],
    subItems: [
      { icon: 'mdi-cached', title: 'Atualizar Certificado', routeName: 'AtualizaCertificado', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR', 'ROLE_USUARIO'] },
      { icon: 'mdi-certificate', title: 'Certificados Digitais', routeName: 'CertificadosDigitais', permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR'] },
      { icon: 'mdi-percent', title: 'Impostos IBS e CBS', routeName: 'ImpostosIbsCbs', permissoes: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR', 'ROLE_MOTORISTA'] },
      { icon: 'mdi-database-import', title: 'Importacao ANTT - RNTRC', routeName: 'ImportacaoAnttRntrc', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-cog-transfer', title: 'Habilitar Integração CIOT', routeName: 'HabilitarIntegracaoCiot', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-file-cancel', title: 'Cancelar CT-e', routeName: 'CancelarCte', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-shield-check', title: 'Averbação CT-e', routeName: 'AverbacaoCte', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-shield-sync', title: 'Averbação CT-e em Lote', routeName: 'AverbacaoCteLote', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-shield-alert', title: 'Relatório Averbação MDF-e', routeName: 'AverbacaoMdfe', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-file-restore', title: 'Reemissão MDF-e', routeName: 'ReemissaoMdfe', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
      { icon: 'mdi-clipboard-text-clock', title: 'Log de Cadastros', routeName: 'LogCadastros', permissoes: ['ROLE_ADMIN', 'ROLE_MODERADOR'] },
    ]
  },
  {
    icon: 'mdi-help-circle',
    title: 'Ajuda',
    section: 'AJUDA',
    url: 'https://wa.me/5598985954728?text=Preciso%20de%20ajuda',
    permissoes: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR', 'ROLE_MOTORISTA']
  },
];

export const baseApiUrl = process.env.VUE_APP_BASE_URL;
export const AuthApiUrl = process.env.VUE_APP_AUTH_URL;
export const MdfeApiUrl = process.env.VUE_APP_MDFE_ENGINE_URL;
export const CteEngineApiUrl = process.env.VUE_APP_CTE_ENGINE_URL;
export const CadastroApiUrl = process.env.VUE_APP_CADASTRO_URL;
export const FinanceiroApiUrl = process.env.VUE_APP_FINANCEIRO_URL;
export const EntregasApiUrl = process.env.VUE_APP_ENTREGAS_URL;
// wi-ciot-api (rota POST /v1/ciot/extratta/viagens da rotina CIOT Avulso).
// Token eh per-usuario - mesmo Bearer do portal. X-Ambiente fixado em
// 'producao' no plugins/http.js (httpCiot).
export const WiCiotApiUrl = process.env.VUE_APP_WI_CIOT_URL || 'https://wi-ciot-api-940621962125.southamerica-east1.run.app';
// wi-nfse-api (Relatorio NFS-e). Sem valor por padrao - diferente das
// outras, nao ha URL conhecida para chutar enquanto a API nao e publicada,
// e por isso ela tambem NAO entra em scripts/verifica-env.js: faltando,
// o portal continua subindo e so o Relatorio NFS-e fica fora (ver o menu
// acima). Para ligar: --build-arg VUE_APP_NFSE_URL no Dockerfile e no
// cloudbuild.yaml, como as demais.
export const NfseApiUrl = process.env.VUE_APP_NFSE_URL || '';